// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_SMS_SIGN_UP_LABELS = 'global.smsSignup';

export const GlobalSmsSignUpLabels = {
  global: {
    smsSignup: {
      lbl_SignUp_signUpForLabel: 'Sign Up For',
      lbl_SignUp_dollarTextLabel: '$',
      lbl_SignUp_joinButtonLabel: 'SIGN UP',
      lbl_SignUp_placeholderText: 'Enter Phone Number',
      lbl_SignUp_shopNowLabel: 'SHOP NOW',
      lbl_SignUp_thankYouTextLabel: 'Thank you for joining',
      lbl_SignUp_joiningTextLabel: '& connecting with us!',
      lbl_SignUp_confirmationMsgReceiveLabel: "You'll receive your first text from us shortly.",
      lbl_SignUp_extraMessageLabel: '',
      lbl_SignUp_imageAlt: 'SMS image alt test',
      lbl_SignUp_submitButtonLabel: 'SUBMIT',
      lbl_smsSignup_privacyPolicy: 'Privacy Policy.',
      lbl_smsSignup_orderUpdates: 'Send me order updates via text messages',
      lbl_SignUp_signupBtn: 'Submit',
      lbl_SignUp_storeLocatorLabel: 'Store Locator',
      lbl_SignUp_offTextLabel_suptext: '',
      lbl_SignUp_offerTypeLabel: 'Join our text alerts!',
      lbl_SignUp_getTextLabel: 'GET',
      lbl_SignUp_offTextLabel: 'OFF*†',
      lbl_SignUp_nextPurchaseLabel: 'Plus stay updated on special offers, new arrivals & more...',
      lbl_combined_signup: 'SIGN UP',
      lbl_combined_noThanks: 'NO THANKS',
      lbl_combined_signup_image_url:
        'https://assets.theplace.com/image/upload/v1624393995/ecom/assets/content/tcp/us/email-sub/Modal-Image-Email.jpg',
      lbl_combined_email_placeholder: 'Enter Email Address',
      lbl_combined_sms_placeholder: 'Enter Phone Number',
      lbl_combined_legal_text:
        '<style>.disclaimer1 {font-size: 9px;font-family: Nunito;color: #1e1e1e}.disclaimer1 a {color: #000}</style><p class="disclaimer1">*Applies to new email and first-time text subscribers to The Children’s Place email marketing and text program. Exclusions apply. Offer valid in stores or online at childrensplace.com or gymboree.com on your next purchase of $40 or more of The Children’s Place or Gymboree branded merchandise. In exchange for this offer, you agree to provide certain personal information for use by The Children’s Place or Gymboree (if applicable). For marketing emails, you can withdraw your consent at any time. For text alerts, carrier message & data rates may apply. Recurring automated marketing messages and cart reminders will be sent to the number provided at opt-in. Frequency varies. No purchase necessary. Text STOP to 89700 to opt out of The Children’s Place texts. Text STOP to 30310 to opt out of Gymboree texts. See <a href="/us/help-center/policies#privacypolicy">Privacy Policy</a>, The Children’s Place Mobile T&C and Gymboree Mobile T&C.</p>',
      lbl_combined_signup_heading: 'Connect with us!',
      lbl_combined_signup_get_text: 'GET',
      lbl_combined_signup_dollar_text: ' $',
      lbl_combined_signup_ten_text: '10 ',
      lbl_combined_signup_off_text: 'OFF',
      lbl_combined_success_heading1: 'WELCOME TO OUR PLACE',
      lbl_combined_success_heading2: 'Thanks for subscribing!',
      lbl_combined_success_message:
        'Check your inbox to redeem your special offer from us. Plus, a text is on its way! Don’t forget to reply Y via to confirm receiving text messages.*',
      lbl_combined_success_image_url:
        'https://assets.theplace.com/image/upload/v1624393995/ecom/assets/content/tcp/us/email-sub/Modal-Image-Email.jpg',
      lbl_combined_shop_now: 'SHOP NOW',
      lbl_combined_cross_brand_check: 'Yes, I’d also like emails from Gymboree',
      lbl_combined_validation_error: 'ERROR: Please enter a valid email address',
      lbl_combined_shop_now_url: '/home',
      lbl_SignUp_genericError: 'Sorry, this phone number is not eligible to be subscribed.',
      lbl_combined_signupSms: "You're in!! Join our text alerts too!!",
    },
  },
};
